import {RsnButton, RsnCheckbox, RsnDialog} from '@raison/ui-kit';
import React, {useState} from 'react';

export function AcknowledgmentDialog({
    title,
    consent,
    disabled = false,
    onContinue,
}: {
    title: string;
    consent: React.ReactNode;
    disabled?: boolean;
    onContinue: () => void;
}) {
    const t = {
        Continue: 'Continue',
    };

    const [checked, setChecked] = useState(false);

    return (
        <RsnDialog.Window>
            <RsnDialog.CenteredHeader>{title}</RsnDialog.CenteredHeader>
            <RsnDialog.Body flex>
                <section className='fv-text-m-regular rounded-md bg-neutral-20 p-5 text-left text-neutral-90'>
                    <RsnCheckbox.Labeled checked={checked} onChange={ev => setChecked(ev.target.checked)}>
                        {consent}
                    </RsnCheckbox.Labeled>
                </section>
            </RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Primary disabled={!checked || disabled} onClick={onContinue}>
                    {t.Continue}
                </RsnButton.Primary>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
